export const data1 = [{
  productId: 14692433330543,
  variantId: 51841194393967,
}]

export const data2 = [{
  productId: 14692433330543,
  variantId: 51841192919407,
}]

export const data3 = [{
  productId: 14692433330543,
  variantId: 51841192952175,
}]